import mapStyles from "../includes/mapStyles.json"

window.map = null
globalWindow = window
mapContainer = document.getElementById("outage-map")

loadPoints = =>
  fetch(mapContainer.dataset.source).then((res) => res.json()).then((json) =>
    bounds = new google.maps.LatLngBounds()

    for point in json.points
      addLocationMarker(point, window.map, bounds)

    if json.points.length
      window.map.fitBounds(bounds)
  )

createMarkerInfoWindow = (point) ->
  template = document.getElementById('marker-infowindow-template').cloneNode(true)
  template.removeAttribute('id')
  template.classList.remove 'hidden'
  template.querySelector('.js-title').innerText = point.title
  template.querySelector('.js-subtitle').innerText = point.subtitle
  template

addLocationMarker = (point, map, bounds) ->
  return unless map?
  position = { lat: point.lat, lng: point.lng }

  marker = new google.maps.Circle({
    strokeColor: "#009A96",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#009A96",
    fillOpacity: 0.5,
    map,
    center: position,
    position: position,
    radius: Math.min(220000, Math.max(150000, Math.sqrt(point.reports) * 5000)),
  })

  bounds.extend(position)

  infoWindow = new google.maps.InfoWindow({
    content: createMarkerInfoWindow(point)
  })  

  marker.addListener 'mouseover', ->
    infoWindow.open(map, marker)

  marker.addListener 'mouseout', ->
    infoWindow.close()

window.initMap = => 
  window.map = new google.maps.Map(mapContainer, {
    center: { lat: 37.0902, lng: -95.7129 } # US by default
    zoom: 4.3
    minZoom: 1
    maxZoom: 7
    styles: mapStyles
    mapTypeControl: false
    streetViewControl: false
  })

  loadPoints()
